import computeClassName from '../../../../../../../../utils/computeClassName';
import { usePartnerSearchContext } from '../../../../../../ContextProvider/Partner/Search';
import MatchingResultCount from './MatchingResultCount';
import CriterionList from './CriterionList';


const constants = Object.freeze({
  CLASSNAME_BASE: 'flex items-center 2xs:space-x-4' //
});

export default function AppliedSearchAndSortCriteria({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { foundPartnerCount } = usePartnerSearchContext();

  return (
    <div className={computedClassName}>
      <MatchingResultCount resultCount={foundPartnerCount} className="hidden 2xs:inline-block flex-shrink-0" />
      <CriterionList/>
    </div>
  );
}

// <p className="text-cc-body-medium sm:text-cc-body-large font-normal mb-1 md:mb-1.5">Tags</p>
